document
    .querySelectorAll('[data-rate]')
    .forEach((rateWidget) => {

        const
            rateSection = rateWidget.querySelector('[data-role="rate"]'),
            resultSection = rateWidget.querySelector('[data-role="result"]');

        rateWidget.addEventListener('click', () => {

            // const grade = e.target.dataset.grade ?? e.target.closest('[data-grade]').dataset.grade;
            rateSection.classList.add('hidden');
            resultSection.classList.remove('hidden');
        });
    });